<template>
	<div class="i2Panel">
		<div class="flex flex-col gap-4 mb-4 md:flex-row">
			<div class="flex flex-col w-full gap-4">
				<div class="flex items-center justify-between w-full gap-2 mb-4">
					<PageLabel :helpPageName="'DashBoardMain'">Hello {{ loggedInUser }}</PageLabel>
					<div class="flex flex-row items-center gap-3">
						<FontAwesomeIcon :icon="['far', 'briefcase']" size="lg" class="colorUserFigures" />
						<b class="colorUserFigures">{{ personParticipationCount.numOfProjects }} PROJECTS</b>
						<FontAwesomeIcon :icon="['far', 'folder']" size="lg" class="colorUserFigures" />
						<b class="colorUserFigures">{{ personParticipationCount.numOfSubProjects }} SUBPROJECTS</b>
						<FontAwesomeIcon :icon="['far', 'clipboard']" size="lg" class="colorUserFigures" />
						<b class="colorUserFigures">{{ personParticipationCount.numOfAssessments }} ASSESSMENTS</b>
					</div>
				</div>

				<div class="flex flex-row w-full mb-4" style="padding-top: 20px">
					<PageLabel :helpPageName="'HistoryLandingPage'">History</PageLabel>
				</div>
				<div class="flex flex-row w-full mb-4" style="padding-top: 20px">
					<DataTable :value="historyList" :loading="loadingHistory" :row-hover="true" responsiveLayout="scroll" dataKey="id" style="width: 100%">
						<template #empty>History is empty. </template>
						<template #loading> Loading History. Please wait. </template>
						<Column field="assessment.subProject.project.projectName" header="Project" :sortable="false">
							<template #body="{ data }">
								<div class="w-full" v-if="data != null" @click="selectAssessment(data.assessment.id)">
									{{ data.assessment.subProject.project.projectName }}
								</div>
							</template>
						</Column>
						<Column field="assessment.subProject.subProjectName" header="SubProject" :sortable="true">
							<template #body="{ data }">
								<div class="w-full" v-if="data != null" @click="selectAssessment(data.assessment.id)">
									{{ data.assessment.subProject.subProjectName }}
								</div>
							</template>
						</Column>
						<Column field="assessment.assessmentName" header="Assessment" :sortable="true">
							<template #body="{ data }">
								<div class="w-full" v-if="data != null" @click="selectAssessment(data.assessment.id)">{{ data.assessment.assessmentName }}</div>
							</template>
						</Column>
						<Column field="assessment.updatedTimeStamp" header="Modified Date" :sortable="true">
							<template #body="{ data }">
								<div class="w-full" v-if="data != null" @click="selectAssessment(data.assessment.id)">
									{{ data.lastAccessTimeStamp ? useDateTimeHelper(data.assessment.updatedTimeStamp).toLocalTimeZoneStandardFormat() : "" }}
								</div>
							</template>
						</Column>
					</DataTable>
				</div>
				<div class="flex flex-row w-full mb-4" style="padding-top: 20px">
					<PageLabel :helpPageName="'FavoritesLandingPage'">Favorites</PageLabel>
				</div>
				<div class="flex flex-row w-full mb-4" style="padding-top: 20px">
					<TreeTable :value="favoritesList" :row-hover="true">
						<Column field="projectName" header="Project" expander
							><template #body="{ node }">
								<div class="w-full" v-if="node.data.projectName !== null" @click="selectAssessment(node.data.assessmentId)">
									{{ node.data.projectName }}
								</div>
							</template>
						</Column>
						<Column field="subProjectName" header="SubProject">
							<template #body="{ node }">
								<div class="w-full" v-if="node.data.subProjectName !== null" @click="selectAssessment(node.data.assessmentId)">
									{{ node.data.subProjectName }}
								</div>
							</template></Column
						>
						<Column field="assessmentName" header="Assessment"
							><template #body="{ node }">
								<div class="w-full" v-if="node.data.assessmentName !== null" @click="selectAssessment(node.data.assessmentId)">
									{{ node.data.assessmentName }}
								</div>
							</template>
						</Column>
						<Column field="modifiedDate" header="Modified Date">
							<template #body="{ node }">
								<div class="w-full" v-if="node.data.modifiedDate" @click="selectAssessment(node.data.assessmentId)">
									{{ node.data.modifiedDate ? useDateTimeHelper(node.data.modifiedDate).toLocalTimeZoneStandardFormat() : "" }}
								</div>
							</template>
						</Column>
					</TreeTable>
				</div>

				<div class="flex flex-row items-center gap-2 mb-4"></div>
			</div>

			<div class="flex flex-col w-full md:w-1/3">
				<!-- <div class="flex flex-col w-full items-start mb-2">
					<button class="btn landingpageUtilitiesButtons justify-start colorLCA" id="btnSP" style="width: 100%" @click="btnEcoSharepoint">
						<span class="flex flex-row w-full items-center justify-start"
							><FontAwesomeIcon :icon="['far', 'link']" size="lg" class="mr-2" /><b>EcoDesign Sharepoint</b></span
						>
					</button>
				</div>

				<div class="flex flex-col w-full items-start mb-2">
					<button class="btn landingpageUtilitiesButtons flex flex-row w-full colorLCA" id="btnLCASP" style="width: 100%" @click="btnLCASharepoint">
						<span class="flex flex-row w-full items-center justify-start"
							><FontAwesomeIcon :icon="['far', 'link']" size="lg" class="mr-2" /><b>LCA Sharepoint</b></span
						>
					</button>
				</div>
				<div class="flex flex-col w-full items-start mb-2">
					<button class="btn landingpageUtilitiesButtons flex flex-row w-full colorLCA" id="btnDocs" style="width: 100%">
						<span class="flex flex-row w-full items-center justify-start"
							><FontAwesomeIcon :icon="['far', 'link']" size="lg" class="mr-2" /><b>Training Documents</b></span
						>
					</button>
				</div>
				<div class="flex flex-col w-full items-start mb-2">
					<button class="btn landingpageUtilitiesButtons flex flex-row w-full colorLCA" id="btnFeedback" style="width: 100%" @click="btnFeedback">
						<span class="flex flex-row w-full items-center justify-start"
							><FontAwesomeIcon :icon="['far', 'comment-minus']" size="lg" class="mr-2" /><b>Feedback</b></span
						>
					</button>
				</div> -->
				<news-feed :expanded="false" :newsList="newsList" @loadModal="callModal" class="flex flex-col w-full" id="newsfeed" />
			</div>

			<!-- </div> -->
		</div>
	</div>
</template>
<script lang="ts" setup>
import { ref, onMounted, watchEffect, watch } from "vue"
import { EventBus } from "../eventBus"
import { ApiClient, DownstreamStep, DownstreamDistribution, News, History, Favorites, PersonParticipationCount } from "../../entities/NSwagGenerated"
import { useToast } from "primevue/usetoast"
import { useRouter } from "vue-router"
import newsFeed from "./newsCard.vue"
import DataTable from "primevue/datatable"
import Column from "primevue/column"
import TreeTable from "primevue/treetable"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
	faListTree,
	faBriefcase,
	faBriefcaseArrowRight,
	faClipboard,
	faBookmark,
	faLink,
	faCommentMinus,
	faFolder,
} from "@fortawesome/pro-regular-svg-icons"
import { SessionInfo } from "@/auth/personSessionData"
import { useDateTimeHelper } from "@/composables/dateTimeHelper"
library.add(faBriefcase, faBriefcaseArrowRight, faClipboard, faBookmark, faLink, faCommentMinus, faFolder, faListTree)

const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())
const toast = useToast()
const router = useRouter()
const newsList = ref([] as News[])
const filteredList = ref([] as News[])
const loading = ref(true)
const loadingHistory = ref(false)
const modalOpened = ref(false)
const newsId = ref()
const loggedInUser = SessionInfo.currentUser().fullName

const historyList = ref()
const favoritesList = ref()
const personParticipationCount = ref<PersonParticipationCount>(
	Object.assign(new PersonParticipationCount(), { numOfAssessments: 0, numOfSubProjects: 0, numOfProjects: 0 })
)
onMounted(() => {
	loadNewsList()
	loadHistory()
	loadFavorites()
	getNumbersForTheUser()
})

const getNumbersForTheUser = () => {
	apiClient.getAllCountsByPersonId(SessionInfo.currentUser().id).then((res) => {
		personParticipationCount.value = res
	})
}
const logSelectedAssessment = (assessmentId: string) => {
	apiClient
		.logSelectedAssessmentPerPersonId(
			Object.assign(new History(), { assessmentId: assessmentId, personId: SessionInfo.currentUser().id, id: self.crypto.randomUUID() })
		)
		.then((res) => {})
}
const selectAssessment = (assessmentId: string) => {
	if (assessmentId === null) return
	logSelectedAssessment(assessmentId)
	EventBus.emit("restSelectedSubTab")
	router.push({ name: "assessment", query: { assessmentId: assessmentId } })
}
const loadHistory = () => {
	loadingHistory.value = true
	apiClient
		.getSelectedAssessmentByPersonId(SessionInfo.currentUser().id)
		.then((res) => {
			//66882
			if (res != null && res.length > 0) {
				historyList.value = res.filter((a) => a.assessment?.isActive)
			}
		})
		.then(() => {
			loadingHistory.value = false
		})
}
const loadFavorites = () => {
	apiClient.getFavoritesTreeByPersonId(SessionInfo.currentUser().id).then((res) => {
		favoritesList.value = res
	})
}
function btnEcoSharepoint() {
	// window.open("https://theermgroup.sharepoint.com/sites/0691921AZEcoDesignTool/Shared%20Documents/Forms/AllItems.aspx")
	//window.open("https://azcollaboration.sharepoint.com/sites/CMU409/SitePages/LCA-Lite.aspx")
}

function btnLCASharepoint() {
	//window.open("https://azcollaboration.sharepoint.com/sites/CMU473/SitePages/Life-Cycle-Assessment-(LCA).aspx")
}

function btnFeedback() {
	// window.open(
	// 	"https://forms.office.com/Pages/ResponsePage.aspx?id=o4mOr6zZL0KtBsxOtCFDFBI9xPNwjxZDoDnYbmTWygpUNzJHR1I2UEJBMUk0WFNENUhDTEs1OFQzTiQlQCN0PWcu"
	// )
}

function btnGoToProjects() {
	router.push("/app/projectList")
}

function btnFavourites() {
	router.push("/app/bookmarkedAssessmentList")
}

function loadNewsList() {
	apiClient.newsFeed().then((result) => {
		if (result != null && result.length > 0) {
			newsList.value = result
			loading.value = false
		}
	})
}

function callModal(paramNewsId: string) {
	let days = 7
	modalOpened.value = true
	document.body.classList.add("modal-open")
	filteredList.value = []
	if (paramNewsId) {
		newsId.value = paramNewsId
		newsList.value.forEach((item) => {
			if (item.id == paramNewsId) {
				filteredList.value.push(item)
			}
		})
	} else {
		newsId.value = ""
		apiClient.newsFeedAll(days).then((result) => {
			filteredList.value = result
			loading.value = false
		})
	}
}
</script>
<style scoped>
.landingpageUtilitiesButtons {
	background-color: var(--p-landingpage-utilities-buttons-background-color);
	color: var(--p-landingpage-utilities-buttons-text-color);
	border: 2px solid var(--p-landingpage-utilities-buttons-text-color);
	padding: 5px 10px;
	font-size: 12px;
	border-radius: 3px;
	cursor: pointer;
	transition: all 0.3s ease;
	text-align: left;
}
.landingpageUtilitiesButtons:hover {
	background-color: var(--p-landingpage-utilities-buttons-background-color-hover);
	color: var(--p-landingpage-utilities-buttons-text-color-hover);
}
.colorLCA {
	color: var(--p-landingpage-utilities-buttons-text-color);
}
.colorLCA:hover {
	color: var(--p-landingpage-utilities-buttons-text-color-hover);
}
.colorUserFigures {
	color: var(--p-landingpage-utilities-buttons-text-project-figures);
}
</style>
